import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ILive, IOtherUserData, IUserData } from "../../helpers/types";
import { AppDispatch, StoreState } from "../../redux/store";
import { fetchUserScheduledEvent } from "../../redux/users/usersSlice";

const useFetchProfileEvent = (id: string, isCurrentUser: boolean) => {
  const dispatch = useDispatch<AppDispatch>();
  const { otherUsers, currentUser, loading, error } = useSelector((state: StoreState) => state.users);
  const [scheduledEvent, setScheduledEvent] = useState<ILive | null>(null);
  const [userToDisplay, setUserToDisplay] = useState<IOtherUserData | IUserData | null>(null);

  useEffect(() => {
    if (!id && !isCurrentUser) return;
    if (!isCurrentUser) {
      const user = otherUsers.find((user: IOtherUserData) => user.id === id);
      if (user && user.event) {
        setScheduledEvent(user.event);
        setUserToDisplay(user);
      } else {
        dispatch(fetchUserScheduledEvent({ id, isCurrentUser: false }));
      }
    } else {
      if (currentUser && currentUser.event) {
        setScheduledEvent(currentUser.event);
        setUserToDisplay(currentUser);
      } else {
        dispatch(fetchUserScheduledEvent({ id, isCurrentUser: true }));
      }
    }
  }, [dispatch, id, otherUsers, currentUser, isCurrentUser]);

  return { loading, error, scheduledEvent, userToDisplay };
};

export default useFetchProfileEvent;
